import React, {useEffect, useState} from 'react'
import {Col, Row} from "react-bootstrap";
import BizLocationSelector from "../../component/BizLocation/BizLocationSelector";
import Page from "../../component/Page/Page";
import Box from "../../component/Box/Box";
import Notify from "../../services/Notify";
import BizStepSelector from "../../component/BizStep/BizStepSelector";
import DispositionSelector from "../../disposition/DispositionSelector";
import AssetService from "../../services/AssetService";
import LatestMovements from "../../component/Card/latestMovements/LatestMovements";

function LsdScreen() {

  const [entity, setEntity] = useState([]);
  const [bizLocationId, setBizLocationId] = useState([])
  const [bizStepId, setBizStepId] = useState([])
  const [dispositionId, setDispositionId] = useState([])

  const assetService = new AssetService()
  const findByLsd = async () => {
    try {
      let query = '?';

      if (bizLocationId.length > 0) {
        const getId = bizLocationId.map(x => x.id)
        query += 'bizLocationIds=' + getId + '&';
      }
      if (dispositionId.length > 0) {
        const getId = dispositionId.map(x => x.id)
        query += 'dispositionIds=' + getId + '&';
      }
      if (bizStepId.length > 0) {
        const getId = bizStepId.map(x => x.id)
        query += 'bizStepIds=' + getId + '&';
      }
      const newEntity = await assetService.findByLsd(query)
      setEntity(newEntity);
    } catch (e) {
      Notify.error('Erro ao recuperar dados do alerta', e);
    }
  }
  useEffect(() => {
    findByLsd()
  }, [bizLocationId, dispositionId, bizStepId]);
  return (
    <Page title="Últimas movimentações">
      <Row>
        <Col md={4}>
          <BizLocationSelector
            multiple
            setValue={e => setBizLocationId(e)}
          />
        </Col>
        <Col md={4}>
          <DispositionSelector
            multiple
            setValue={e => setDispositionId(e)}
          />
        </Col>
        <Col md={4}>
          <BizStepSelector
            multiple
            setValue={e => setBizStepId(e)}
          />
        </Col>
      </Row>
      <Box>
        {bizLocationId.length >0 ?
          <LatestMovements
            data={entity}
            location={bizLocationId}
          /> :
          <h1 style={{justifyContent: 'center', display: 'flex'}}>
            Selecione um local
          </h1>
        }
      </Box>
    </Page>
  )
}
export default LsdScreen;



// WEBPACK FOOTER //
// ./src/pages/Lsd/LsdScreen.js